export default "__VITE_ASSET__CsSFbATW__"